import React from 'react'
import banner from '../../assets/images/overview.png'

const FellowshipBanner = () => {
    return (
        <section className="page-header" style={{ marginTop: "71px" }}>
          <div
            className="page-header-bg"
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
          <div className="container">
            <div className="page-header__inner">
              <h2>Fellowship</h2>
              <ul className="thm-breadcrumb list-unstyled">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <span>/</span>
                </li>
                <li className="active">Fellowship</li>
              </ul>
            </div>
          </div>
        </section>
      );
}

export default FellowshipBanner